import App from './App.html';
import * as tf from '@tensorflow/tfjs';
import {range, within, shuffle, randomId, getQuery, getTurkInfo, setCookie, getCookie, setupDimensionMetadata, copyArray, sampleOne, Model, timeseriesExample, rotatedTimeseriesExample, timeseriesLimits, timeseriesPcts, checkPermitted} from './utils';
window.tf = tf;

const rootUrl = location.pathname.split('/').slice(0,-1).join('/') + '/models';

const cookieId = 'dtakquizsession';
if (getCookie(cookieId)) {
  const userId = getCookie(cookieId);
  window.userId = userId;
} else {
  const userId = randomId();
  setCookie(cookieId, userId, 1);
  window.userId = userId;
}

window.session = `142857_${randomId()}`;

let app = null;

async function load(dataKey, modelKeys) {
  const modelPromises = modelKeys.map(modelKey => {
    if (dataKey == 'timeseries' && modelKey == 'supervised') {
      return new Promise((resolve, reject) => {
        const model = new Model({
          decoder: timeseriesExample,
          dataKey: 'timeseries',
          modelKey: 'supervised',
          z_lims: timeseriesLimits,
          z_pcts: timeseriesPcts,
          Dx: 64,
          Dz: 5,
          Dc: [],
          hierarchy: [
            { type: 'continuous' },
            { type: 'continuous' },
            { type: 'continuous' },
            { type: 'continuous' },
            { type: 'continuous' }
          ]
        });
        resolve(model);
      });
    } else if (dataKey == 'timeseries' && modelKey == 'supervised_rotated') {
      return new Promise((resolve, reject) => {
        const c = Math.cos(Math.PI / 12.0);
        const model = new Model({
          decoder: rotatedTimeseriesExample,
          dataKey: 'timeseries',
          modelKey: 'supervised_rotated',
          z_lims: [[-c,c],[-c,c],[-c,c],[-c,c],[-1,1]],
          Dx: 64,
          Dz: 5,
          Dc: [],
          hierarchy: [
            { type: 'continuous' },
            { type: 'continuous' },
            { type: 'continuous' },
            { type: 'continuous' },
            { type: 'continuous' }
          ]
        });
        resolve(model);
      });
    } else {
      return Promise.all([
        tf.loadFrozenModel(`${rootUrl}/${dataKey}/${modelKey}/decoder_web/tensorflowjs_model.pb`,
                           `${rootUrl}/${dataKey}/${modelKey}/decoder_web/weights_manifest.json`),
        fetch(`${rootUrl}/${dataKey}/${modelKey}/config.json`).then(async (resp) => await resp.json())
      ]).then(responses => {
        const decoder = responses[0];
        const config = responses[1];
        config.decoder = decoder;
        config.modelKey = modelKey;
        config.dataKey = dataKey;
        return new Model(config);
      });
    }
  });

  const viz = getQuery('viz') || 'sliders';
  const wid = getTurkInfo().workerId;
  let embedded = false;
  if (getQuery('workerId')) {
    embedded = true;
  }
  let permitted;
  if (getQuery('permitted') || getQuery('skip_instructions')) {
    permitted = true;
  } else {
    permitted = await checkPermitted();
  }
  const appDiv = document.getElementById('app');
  if (permitted === false) {
    appDiv.innerHTML = "<div class='warning-message'>It looks like you've already completed a similar HIT in the past! Unfortunately, for this study we require that each respondent be unique. <strong>Please return this HIT to avoid any impact on your approval rating.</strong> We apologize for any inconvenience or lack of clarity.</div>"
  } else {
    appDiv.innerHTML = '';
    app = new App({
      target: appDiv,
      data: { dataKey, modelKeys, viz, modelPromises, embedded, compcode: window.session }
    });
  }
}

const dataset = getQuery('dataset') || 'dsprites';
let models = getQuery('models');
if (models) {
  models = models.split('|');
} else {
  if (dataset == 'dsprites') {
    models = shuffle(['conv_supervised','conv_vae','conv_ae']);
  } else if (dataset == 'timeseries') {
    models = shuffle(['supervised','fc_vae','fc_ae']);
  }
}
load(dataset, models);

export default app;
